import React from 'react';
import { Format } from '../../../lib/dateFns';
import utilsStyles from '../../../styles/modules/utils.module.scss';
import { formatDateCommon } from '../../../utils/formatters';
import styles from './TradeInfoBox.module.scss';

export type TradeInfoBoxProps = {
  tradeRequestId: string;
  tradeAt: string;
};

function TradeInfoBox({ tradeRequestId, tradeAt }: TradeInfoBoxProps) {
  return (
    <div className={`${styles.section}`}>
      <div className={`${styles.infoList} ${utilsStyles.textSmall}`}>
        <p className={styles.infoItem}>交換申請ID：{tradeRequestId}</p>
        <p className={styles.infoItem}>取消可能日時：{formatDateCommon(tradeAt, Format.dateTimeLotteryJa)}まで</p>
      </div>
    </div>
  );
}

export default TradeInfoBox;
